import React from 'react'
import axios from 'axios';
import * as IoIcons from 'react-icons/io';
import Swal from "sweetalert2";
function EliminarClasificacion(props) {
    const Eliminar = e => {
        e.preventDefault(e)
        axios({
          auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },
            method: 'post',
            url: "http://172.16.100.79:8017/api/EliminaClasificacion?Id="+props.id,
            data: {
                
            }
        })
        .then((Response) => {
            console.log(Response.data)
            Swal.fire({
                title: "eliminado con exito!",
                text: "Eliminado",
                icon: "success",
               
              },
             );
             window.location.reload("/")
        }).catch((error) => {
            console.log(error)
            Swal.fire({
              title: "No se puedo eliminar",
              text: "Intentelo de nuevo",
              icon: "error",
             
            },
           );
        })
    };
  return (
    <div>
            <button variant="contained" className='btn btn-danger' color="primary" onClick={Eliminar} >  <IoIcons.IoIosCloseCircle /> </button>


    </div>
  )
}

export default EliminarClasificacion